import {UmpireImage} from '../umpire-image';
import {UmpirePublicationOptions} from '../umpire-publication-options';
import {UmpireVisibilityOptions} from '../umpire-visibility-options';
import {UmpireQuizQuestion} from '../umpire-quiz-question';
import {UmpireQuizRanking} from '../umpire-quiz-ranking';
import {UmpireQuizAnswer} from '../umpire-quiz-answer';

export class UmpireQuiz implements UmpirePublicationOptions {
  id!: string | null;

  client_id!: string | null;

  end_time!: string | null;

  image!: Partial<UmpireImage> | null;

  is_draft!: boolean;

  name!: string | null;

  number_of_attempt_questions!: number | null;

  publication_time!: string | null;

  published_at!: string | null;

  seconds_for_answer!: number | null;

  signed_in_only!: boolean;

  quiz_questions!: UmpireQuizQuestion[];

  type!: 'quiz';

  visibility!: UmpireVisibilityOptions;

  quiz_ranking!: UmpireQuizRanking | null;

  quiz_rankings!: UmpireQuizRanking[] | null;

  relationshipNames!: string[];

  slug!: string | null;

  finished_at!: string | null;

  quiz_user_answers!: UmpireQuizUserAnswer[];

  points!: number | null;

  total_answers_time!: number | null;
}

export interface UmpireQuizUserAnswer {
  type: 'quiz_user_answer';
  correct_quiz_answer_id?: string;
  answer_time: number;
  quiz: UmpireQuiz;
  quiz_answer: UmpireQuizAnswer;
  quiz_question: UmpireQuizQuestion;
  relationshipNames: string[];
}
